<template>

    <div class="centralized pdtb2 library-quiz">

        <header class="registration-header">

            <h1 v-if="current_question === 0">Hey, {{ user.first_name }}.<br>Help us personalise your workouts by answering some quick questions:</h1>
            <h2>{{question_data[current_question].title}}</h2>

            <p v-if="current_question === 1"><i style="font-size: 12px;">The Hub is based on consistency and building your new habit. If it’s your first time taking the quiz, we recommend that you begin with 10 minute routines.</i></p>
            <p v-if="current_question === 2"><i style="font-size: 12px;">Following ‘The Book On Video’ requires you to manually adjust your programme as you improve. If you would prefer less customisation within your programme please choose option ‘No’.</i></p>

            <div class="registration-breadcrumbs">
                <span v-if="current_question <= 2">{{ current_question + 1 }}/{{ question_data.length - 1 }}</span>
                <span v-else>{{ current_question }}/{{ question_data.length - 1 }}</span>
            </div>
        </header>

        <div class="primary-form">

            <div class="iwd-option-btn"
                 v-for="(answer, index) in question_data[current_question].answers"
                 @click="setAnswer(index, answer)"
                 :class="{
                    selected: question_data[current_question].answer === index
                 }"
            >{{ answer }}</div>

            <div class="wspan fxrbc mt200">
                <a href="#" :class="{hidden: current_question === 0}" @click.prevent="previous">Previous</a>
                <a href="#" :class="{disabled: question_data[current_question].answer === null || submitting, 'standard-loading-message': submitting }" @click.prevent="next">{{ next_btn_text }}</a>
            </div>
        </div>

    </div>

</template>

<script>

export default {
    props: [
        'user'
    ],
    data()
    {
        return {
        	question_data: [
        		{
                    title: 'How would you describe your current movement?',
                    answers: [
                    	'Pretty tight',
                        'Flexible in some areas',
                        'Quite supple'
                    ],
                    answer: null
                },
        		{
                    title: 'Please choose the daily timeframe you wish to work in.',
                    answers: [
                    	  '10 minute routines',
                        '15 minute routines',
                        '20 minute routines',
                        '30 minute routines',
                        '40 minute routines',
                        '1 hour routines'
                    ],
                    answer: null
                },
        		{
                    title: 'The Hub also includes Roger\'s book ‘The Flexible Body’ on video. Would you like to include the chapters from that too as part of your training?',
                    answers: [
                    	'Yes',
                        'No'
                    ],
                    answer: 1
                },
        		{
                    title: 'Would you like to include upside-down exercises as part of your training, i.e. headstands & handstands?',
                    answers: [
                    	'No',
                    	'Sure, I’ll give it a try.'
                    ],
                    answer: null
                },
        		{
                    title: 'What would you like included in your routine?',
                    answers: [
                    	'Flexibility',
                        'Strength',
                        'A combination of the two'
                    ],
                    answer: null
                },
        		{
                    title: 'Do you have a bar to hang from for hanging exercises?',
                    answers: [
                        'Yes',
                        'No'
                    ],
                    answer: null
                },
        		{
                    title: 'Do you have weights for additional weighted stretches?',
                    answers: [
                        'Yes',
                        'No'
                    ],
                    answer: null
                }
            ],
            current_question: 0,
            next_btn_text: 'Next',
            complete: false,
            submitting: false
        }
    },
    mounted()
    {

    },
    methods: {
    	setAnswer(answer_index, answer)
        {
        	this.question_data[this.current_question].answer = answer_index;
        },
        previous()
        {
        	if(this.current_question)
            {
              if(this.current_question === 3){
                this.current_question = 1;
              }else{
                this.current_question--;
              }
            }
        },
        next()
        {
            if(this.complete)
            {
                this.postToUrl('/quiz', {
                    question_data: JSON.stringify(this.question_data)
                });
                this.next_btn_text = 'working...';
                this.submitting = true;
            	return true;
            }
            if(this.current_question === 1){
              this.current_question = 3;
            }else{
              this.current_question++;
            }
        }
    },
    watch: {
        current_question: function(newv){
        	if(newv === this.question_data.length - 1)
            {
                this.next_btn_text = 'OK, finish';
                this.complete = true;
            }else{
                this.next_btn_text = 'Next';
                this.complete = false;
            }
        },
    }
}

</script>
